import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { plotStages } from "@/mocks/film";

export default function PlotTimeline() {
  return (
    <section id="plot" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Story Line"
              title="剧情脉络：六个阶段看懂故事走向"
              desc="全片以主角向西的成长为轴心，可以按时间顺序拆成六个阶段。建议从上往下读，能清楚看到他的心态是怎样一步步被推着改变的。"
            />
          </Reveal>

          <div className="mt-12 md:mt-16 relative">
            <div className="absolute left-[27px] md:left-1/2 top-2 bottom-2 w-px bg-background-200 md:-translate-x-1/2" />

            <div className="space-y-8 md:space-y-12">
              {plotStages.map((stage, index) => {
                const isRight = index % 2 === 1;
                return (
                  <Reveal key={stage.order} delay={index * 60}>
                    <div className="relative flex flex-col md:flex-row md:items-start">
                      <div className="hidden md:block md:w-1/2 md:pr-12" />

                      <span className="absolute left-0 md:left-1/2 top-1 md:-translate-x-1/2 z-10 w-14 h-14 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-bold text-lg border-4 border-background-50">
                        {stage.order}
                      </span>

                      <div
                        className={`w-full md:w-1/2 pl-20 md:pl-0 ${
                          isRight ? "md:pl-12" : "md:pr-12 md:order-first"
                        }`}
                      >
                        <div className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200">
                          <div className="flex flex-wrap items-center gap-3">
                            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                              {stage.title}
                            </h3>
                            <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 font-label text-xs whitespace-nowrap">
                              {stage.period}
                            </span>
                          </div>
                          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
                            {stage.desc}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}